// HealthLabs cart context readiness installer. Generated for ro_hlp.
(function () {
"use strict";
function installCartContextReadiness(window, document, options) {
  'use strict';
  if (window.__HLX_CART_BRIDGE_INSTALL) return window.__HLX_CART_BRIDGE_INSTALL;
  const SHOP = options.shop;
  const startedAt = Date.now();
  let timer, bridge = null, stopped = false, state = 'waiting';
  let featurePending = false, featureDeadline = 0, featureRetryAt = 0, featureAttempts = 0;

  function removeReadinessListeners() {
    window.clearTimeout(timer);
    document.removeEventListener('DOMContentLoaded', tick);
    document.removeEventListener('visitorConsentCollected', tick);
    document.removeEventListener('visibilitychange', visible);
    window.removeEventListener('pageshow', tick);
  }
  function stop() {
    stopped = true;
    state = 'stopped';
    removeReadinessListeners();
    bridge?.stop();
  }
  function visible() { if (document.visibilityState === 'visible') tick(); }
  function featureComplete(attempt, error) {
    if (attempt !== featureAttempts) return;
    featurePending = false;
    if (stopped || bridge) return;
    featureRetryAt = Date.now() + (error ? Math.min(60000, 2000 * 2 ** Math.min(featureAttempts, 5)) : 2000);
    tick();
  }
  function tick() {
    if (stopped || bridge) return;
    window.clearTimeout(timer);
    try {
      if (window.location?.protocol !== 'https:') { stop(); return; }
      const shopify = window.Shopify;
      if (shopify?.shop && shopify.shop !== SHOP) { stop(); return; }
      // Wait for both documented purpose readers, not a partially hydrated privacy object.
      // The runtime independently denies missing/throwing methods if the API later disappears.
      const privacyReady = typeof shopify?.customerPrivacy?.marketingAllowed === 'function' &&
        typeof shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function';
      if (shopify?.shop === SHOP && privacyReady && typeof window.fetch === 'function' &&
          typeof window.HLXInstallCartContextBridge === 'function') {
        // The reviewed factory installs consent/visibility/page lifecycle handlers and starts a quiet sync.
        bridge = window.HLXInstallCartContextBridge();
        if (!bridge || typeof bridge.sync !== 'function' || typeof bridge.stop !== 'function') {
          bridge = null;
          throw new Error('bridge_unavailable');
        }
        state = 'installed';
        removeReadinessListeners();
        return;
      }
      if (featurePending && Date.now() >= featureDeadline) featurePending = false;
      if (shopify?.shop === SHOP && !privacyReady && !featurePending && Date.now() >= featureRetryAt &&
          typeof shopify.loadFeatures === 'function') {
        featurePending = true;
        featureAttempts++;
        featureDeadline = Date.now() + 8000;
        featureRetryAt = Date.now() + Math.min(60000, 2000 * 2 ** Math.min(featureAttempts, 5));
        const attempt = featureAttempts;
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
          error => featureComplete(attempt, error));
      }
    } catch {
      // No checkout/form/fetch interception and no unhandled failure in the storefront.
    }
    // loadFeatures may call back synchronously. Keep a single readiness timer.
    window.clearTimeout(timer);
    if (!stopped && !bridge) timer = window.setTimeout(tick, Date.now() - startedAt < 30000 ? 1000 : 15000);
  }
  window.__HLX_CART_BRIDGE_INSTALL = Object.freeze({ version: '1.1.0',
    getState: () => state, stop });
  document.addEventListener('DOMContentLoaded', tick);
  document.addEventListener('visitorConsentCollected', tick);
  document.addEventListener('visibilitychange', visible);
  window.addEventListener('pageshow', tick);
  tick();
  return window.__HLX_CART_BRIDGE_INSTALL;
}

installCartContextReadiness(window, document, Object.freeze({"instanceId":5,"shop":"ru-healthlabs-pharm.myshopify.com"}));
})();
